import {API_DRIVER} from "../config/axios";

const getWishCodesRequestUrl = (endpointUrl: string) => {
    return `/api/wish-codes${endpointUrl}`
}


const WishCodeService = {
    fetchCodes: (wishId: string) => {
        return API_DRIVER.get(getWishCodesRequestUrl(`/${wishId}`), {})
    },
    uploadWishCodes: (wishId: string, file: File) => {
        const formData = new FormData()
        formData.append("file", file)

        return API_DRIVER.post(getWishCodesRequestUrl(`/${wishId}/upload`), formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
    },
    deleteCode: (id: string) => {
        return API_DRIVER.delete(getWishCodesRequestUrl(`/${id}`))
    }
}

export default WishCodeService
